<template>
  <div class="real-time-monitoring-container">
    <div class="page-content">
      <div class="operation-bar">
        <el-button type="primary" size="mini" @click="handleCreate">+新增</el-button>
        <el-button type="danger" size="mini" @click="handleBatchDelete" :disabled="!selectedRows.length"
          >删除</el-button
        >
        <div class="search-box">
          <span style="margin-right: 10px; color: #fff">所属企业</span>
          <el-select v-model="searchTenantId" placeholder="请选择" style="width: 200px" size="mini" clearable>
            <el-option v-for="item in tenantOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <span style="margin: 0 10px; color: #fff">所属大棚</span>
          <el-select v-model="searchGreenhouseId" placeholder="请选择" style="width: 200px" size="mini" clearable>
            <el-option v-for="item in greenhouseOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button icon="el-icon-search" style="margin-left: 10px" size="mini" type="primary" @click="handleSearch"
            >查询</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="80" align="center"> </el-table-column>
        <el-table-column prop="tenantName" label="所属企业"></el-table-column>
        <el-table-column prop="greenhouseName" label="所属大棚"></el-table-column>
        <el-table-column prop="monitorName" label="视频名称"></el-table-column>
        <el-table-column prop="videoCode" label="视频编码"></el-table-column>
        <el-table-column prop="monitorUrl" label="视频链接"></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{ formatTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" style="color: #2680dd" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #04ff9f" @click="handleView(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="78vw" @close="handleDialogClose">
      <div class="dialog-content">
        <div class="section-title">实时监控</div>
        <el-table :data="formData.monitors" border style="width: 100%">
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column label="*所属企业" width="200">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.tenantId"
                placeholder="请选择 (企业角色的账户名称)"
                style="width: 100%"
                @change="handleTenantChange(scope.$index)"
              >
                <el-option v-for="item in tenantOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="*所属大棚" width="200">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.greenhouseId"
                placeholder="请选择 (该企业下大棚编号)"
                style="width: 100%"
                @change="handleGreenhouseChange(scope.$index)"
              >
                <el-option v-for="item in greenhouseOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="*视频名称" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.monitorName" placeholder="请输入" style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="视频编码" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.videoCode" placeholder="请输入" style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*视频链接">
            <template slot-scope="scope">
              <el-input v-model="scope.row.monitorUrl" placeholder="请输入" style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" v-if="!isEdit" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="removeMonitor(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="add-button-container" v-if="!isEdit">
          <el-button
            type="primary"
            icon="el-icon-plus"
            plain
            style="margin: 10px 0; width: 100%"
            size="mini"
            @click="addMonitor"
            >添加</el-button
          >
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确定</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情弹窗 -->
    <el-dialog title="查看详情" :visible.sync="viewDialogVisible" width="78vw" @close="handleViewDialogClose">
      <div class="dialog-content">
        <div class="section-title">实时监控</div>
        <el-table :data="viewFormData.monitors" border style="width: 100%">
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column label="所属企业" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.tenantName" readonly style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="所属大棚" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.greenhouseName" readonly style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="视频名称" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.monitorName" readonly style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="视频编码" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.videoCode" readonly style="width: 100%"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="视频链接">
            <template slot-scope="scope">
              <el-input v-model="scope.row.monitorUrl" readonly style="width: 100%"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';

export default {
  name: 'RealTimeMonitoring',
  data() {
    return {
      tableData: [],
      selectedRows: [],
      searchTenantId: '',
      searchGreenhouseId: '',
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      dialogTitle: '新增',
      formData: {
        monitors: [],
      },
      isEdit: false,
      viewDialogVisible: false,
      viewRow: {},
      viewFormData: {
        monitors: [],
      },
      tenantOptions: [],
      greenhouseOptions: [],
      allGreenhouseOptions: {}, // 按企业分组的棚选项
    };
  },
  created() {
    this.fetchData();
    this.fetchTenantOptions();
    this.fetchGreenhouseOptions();
  },
  methods: {
    // 获取企业列表
    async fetchTenantOptions() {
      const res = await axios.get(baseUrl + '/api/system/users');
      // 过滤出角色为企业的用户
      const agriTechUsers = res.data.filter(
        (user) => user.roleCodes && user.roleCodes.split(',').includes('company_admin')
      );
      this.tenantOptions = agriTechUsers.map((item) => ({
        label: item.nickName,
        value: item.id,
      }));
    },
    // 获取大棚列表
    async fetchGreenhouseOptions() {
      const formData = new FormData();
      formData.append('enableStatus', 1);
      const greenhouseRes = await axios.post(baseUrl + '/api/basic/greenhouse/selection', formData);
      this.greenhouseOptions = greenhouseRes.data.map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
    },
    // 获取企业下大棚列表
    async fetchGreenhouseOptionsByTenant(tenantId) {
      const formData = new FormData();
      formData.append('tenantId', tenantId);
      formData.append('enableStatus', 1);

      const greenhouseRes = await axios.post(baseUrl + '/api/basic/greenhouse/selection', formData);
      console.log('greenhouseRes', greenhouseRes);
      this.greenhouseOptions = greenhouseRes.data.map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
    },
    // 获取监控列表
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          tenantId: this.searchTenantId,
          greenhouseId: this.searchGreenhouseId,
        };
        const res = await axios.post(baseUrl + '/api/monitor/list-page', params);
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleCreate() {
      this.isEdit = false;
      this.dialogTitle = '新增';
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.formData = {
          monitors: [],
        };
        // 添加1个默认行
        this.addMonitor();
      });
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = '编辑';
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.formData = {
          monitors: [
            {
              id: row.id,
              tenantId: row.tenantId,
              tenantName: row.tenantName,
              greenhouseId: row.greenhouseId,
              greenhouseName: row.greenhouseName,
              monitorName: row.monitorName,
              videoCode: row.videoCode,
              monitorUrl: row.monitorUrl,
            },
          ],
        };
      });
    },
    handleView(row) {
      this.viewRow = { ...row };
      this.viewFormData = {
        monitors: [
          {
            id: row.id,
            tenantId: row.tenantId,
            tenantName: row.tenantName,
            greenhouseId: row.greenhouseId,
            greenhouseName: row.greenhouseName,
            monitorName: row.monitorName,
            videoCode: row.videoCode,
            monitorUrl: row.monitorUrl,
          },
        ],
      };
      this.viewDialogVisible = true;
    },
    handleDialogClose() {
      this.isEdit = false;
      this.formData = {
        monitors: [],
      };
    },
    handleViewDialogClose() {
      this.viewFormData = {
        monitors: [],
      };
    },
    async handleSubmit() {
      // 验证表单数据
      if (!this.formData.monitors || this.formData.monitors.length === 0) {
        this.$message.error('请至少添加一条监控记录');
        return;
      }

      // 验证每个监控项
      for (let i = 0; i < this.formData.monitors.length; i++) {
        const monitor = this.formData.monitors[i];
        if (!monitor.tenantId) {
          this.$message.error(`第${i + 1}行：请选择所属企业`);
          return;
        }
        if (!monitor.greenhouseId) {
          this.$message.error(`第${i + 1}行：请选择所属大棚`);
          return;
        }
        if (!monitor.monitorName || !monitor.monitorName.trim()) {
          this.$message.error(`第${i + 1}行：请输入视频名称`);
          return;
        }
        if (!monitor.monitorUrl || !monitor.monitorUrl.trim()) {
          this.$message.error(`第${i + 1}行：请输入视频链接`);
          return;
        }
      }

      try {
        if (this.isEdit) {
          // 编辑模式
          const submitData = this.formData.monitors[0];
          const url = '/api/monitor/edit';
          const res = await axios.post(baseUrl + url, submitData);
          if (res.code === 200) {
            this.$message.success('更新成功');
            this.dialogVisible = false;
            this.fetchData();
          }
        } else {
          // 新增模式
          console.log('this.formData.monitors', this.formData.monitors);
          const submitData = {
            items: this.formData.monitors.map((monitor) => ({
              tenantId: monitor.tenantId,
              tenantName: this.tenantOptions.find((t) => t.value === monitor.tenantId)?.label || '',
              greenhouseId: monitor.greenhouseId,
              greenhouseName: monitor.greenhouseName,
              monitorName: monitor.monitorName.trim(),
              videoCode: monitor.videoCode ? monitor.videoCode.trim() : '',
              monitorUrl: monitor.monitorUrl.trim(),
            })),
          };
          const url = '/api/monitor/add-batch';
          const res = await axios.post(baseUrl + url, submitData);
          if (res.code === 200) {
            this.$message.success('新增成功');
            this.dialogVisible = false;
            this.fetchData();
          }
        }
      } catch (error) {
        console.error('提交失败:', error);
      }
    },
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个监控记录吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(baseUrl + '/api/monitor/delete-batch', ids);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      return date
        .toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
        .replace(/\//g, '/');
    },

    // 根据企业ID获取对应的大棚选项
    getGreenhouseOptionsByTenant(tenantId) {
      if (!tenantId) return [];
      return this.allGreenhouseOptions[tenantId] || [];
    },
    // 企业变化处理
    async handleTenantChange(index) {
      const monitor = this.formData.monitors[index];
      // 清空大棚选择
      monitor.greenhouseId = '';
      monitor.greenhouseName = '';

      // 获取该企业下的大棚列表
      if (monitor.tenantId) {
        await this.fetchGreenhouseOptionsByTenant(monitor.tenantId);
      }
    },
    // 大棚变化处理
    handleGreenhouseChange(index) {
      const monitor = this.formData.monitors[index];
      const selectedGreenhouse = this.greenhouseOptions.find((item) => item.value === monitor.greenhouseId);
      if (selectedGreenhouse) {
        monitor.greenhouseName = selectedGreenhouse.label;
      }
    },
    // 添加监控行
    addMonitor() {
      this.formData.monitors.push({
        id: undefined,
        tenantId: '',
        tenantName: '',
        greenhouseId: '',
        greenhouseName: '',
        monitorName: '',
        videoCode: '',
        monitorUrl: '',
      });
    },
    // 删除监控行
    removeMonitor(index) {
      this.formData.monitors.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="less">
.real-time-monitoring-container {
  .page-content {
    background: rgba(0, 11, 47, 0.3);
    padding: 20px;
    border-radius: 4px;

    .operation-bar {
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .search-box {
        margin-left: auto;
        display: flex;
        align-items: center;
      }
    }

    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }
  }

  .dialog-content {
    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #333;
    }

    .add-button-container {
      text-align: center;
      border-radius: 4px;
    }
  }
}
</style>
